<template>
  <div style="padding:30px 66px;" v-if="true">
    <el-steps :active="currentStep" align-center class="cus-steps">
      <el-step title="上传数据"></el-step>
      <el-step title="导入数据"></el-step>
      <el-step title="导入完成"></el-step>
    </el-steps>
    <el-button v-if="currentStep < 1" type="primary" style="width: 100%;height:40px;margin-top:50px;"
               :loading="currentStep !== 0 && currentStep !== 3" @click.prevent="importFile">立即导入
    </el-button>
    <div v-if="currentStep === 1" style="text-align: center;padding-bottom:40px;margin-top:90px;">
      <i style="font-size: 48px" class="el-icon-loading"></i>
      <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 300;color: #999999;margin-top:12px;">
        正在导入
      </div>
    </div>
    <!-- 有问题按键-->
    <el-button v-if="currentStep === 3 && operationRecordId" type="primary"
               style="width: 100%;height:40px;margin-top:50px;"
               @click.prevent="showDetail = true; getResult(operationRecordId)">查看详情
    </el-button>
    <div v-if="currentStep === 3 && !operationRecordId && !importStatus"
         style="text-align: center;margin-top: 80px;padding-bottom: 40px;">
      <div>
        <i style="font-size: 64px;color:#FF553E" class="el-icon-circle-close"></i>
      </div>
      <span style="margin-top:12px;color:#FF553E;">{{ this.exportMessage }}</span>
    </div>
    <div v-if="currentStep === 3 && importStatus" style="text-align: center;margin-top: 80px;padding-bottom: 40px;">
      <div>
        <i style="font-size: 64px;color:#458CFF" class="el-icon-circle-check"></i>
      </div>
      <span style="margin-top:12px;">导入成功！</span>
    </div>
    <!-- 第一页显示 -->
    <div v-if="currentStep < 1" style="color: #2A2A2A;font-size: 16px;font-weight: 300;margin-top:47px;">
      <div style="margin-bottom: 17px;">温馨提示:</div>
      <div>1、如果您还没有下载导入模板，请下载 <span @click.prevent="downTemplate"
                                    style="cursor: pointer; color:#458CFF; text-decoration: underline;">模版</span>
      </div>
      <div style="margin-top: 14px;">2、单次可导入{{this.dataSize}}条以内的数据</div>
    </div>
  </div>
</template>
<script>


// 表单单组件
export default {
  // props: {
  //   importShow: {
  //     type: Boolean,
  //     default: () => {
  //       return false;
  //     },
  //   },
  //   currentStep: {
  //     type: Number,
  //     default: () => {
  //       return 0;
  //     },
  //   },
  //   importStatus: {
  //     type: Boolean,
  //     default: () => {
  //       return false;
  //     },
  //   }
  // },
  watch: {},
  data() {
    return {
      importShow: false,
      currentStep: 0,
      importStatus: false,
      errorData: [],
      errorCount: 0,
      errPageNo: 1,
      operationRecordId: '',
      showDetail: false,
      total: 0,
      exportMessage: '导入失败,请严格按照模版格式进行导入',
      dataSize: 500,
    }
  },
  created() {
  },
  methods: {
    getResult({operationRecordId = this.operationRecordId, pageNumber = this.errPageNo, pageSize = 10}) {
      const param =
        {
          pageNumber,
          pageSize,
          operationRecordId
        }
      this.$axios.fetchPost(api.archives.getErrorReason, param).then(res => {
        console.log(res)
        this.errorData = res.data.records
        this.errorCount = res.data.total;
      })
    },
    // 判断文件类型
    isExcellType(ext) {
      return ['xls', 'xlsx'].indexOf(ext.toLowerCase()) !== -1;
    },
    importFile() {
      this.$emit("importFile", '');
      // if (this.importUrl) {
      //   this.$message({message: '导入连接获取异常', type: 'warning'});
      //   return;
      // }
      // this.$confirm('只能上传.xls/.xlsx文件')
      //   .then(_ => {
      //     this.$utils.uploadFile((file) => {
      //       console.log(file)
      //       this.importStatus = false; // 在这里初始化了导入的状态
      //       this.currentStep = 1;
      //       let formData = new FormData();
      //       formData.append('file', file);
      //       let index = file.name.lastIndexOf('.');
      //       let ext = file.name.substr(index + 1);
      //       if (!this.isExcellType(ext)) {
      //         this.currentStep = 0
      //         this.$message.warning('只能上传.xls/.xlsx文件!')
      //       } else {
      //         this.$axios
      //           .fetchPostGoodsExport(api.archives.barCodeImport, formData)
      //           .then(data => {
      //             console.log(data)
      //             this.currentStep = 2;
      //             if (data.code === 200) {
      //               this.operationRecordId = data.data
      //               this.importStatus = true
      //               this.getTableData();
      //               this.$notify({
      //                 type: "success",
      //                 title: '导入操作',
      //                 message: '成功',
      //                 showClose: false,
      //               });
      //               // return this.$message({message: '导入成功!', type: 'success'})
      //             } else {
      //               if (data.errorMsg) {
      //                 return this.$message({message: data.errorMsg, type: 'warning'});
      //               } else {
      //                 return this.$message({message: '导入异常', type: 'error'});
      //               }
      //             }
      //           }).catch((err) => {
      //           console.lg(err)
      //         }).finally(() => {
      //           this.currentStep = 3
      //           this.getTableData()
      //         });
      //       }
      //     });
      //   }).catch(() => {
      //   this.showUpload = false
      //   this.currentStep = 0
      // })
    },
    downTemplate() {
      this.$emit("downTemplate", '');
      // console.log(this.downTemplateUrl);
      // if (this.downTemplateUrl) {
      //   this.$message({message: '模版连接获取异常', type: 'warning'});
      //   return;
      // }
      // this.$axios.fetchPost(this.downTemplateUrl).then(data => {
      //   if (data.code === 200) {
      //     const elink = document.createElement('a');
      //     elink.href = data.data;
      //     elink.click();
      //   } else {
      //     this.$message({message: data.errorMsg, type: 'error'});
      //   }
      // });
    },
  }
}
</script>

<style scoped>

.setCode .button {
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 20px;
}

/deep/ .barCodeDialog {
  min-width: 500px;
}

/deep/ .checkBarCode {
  min-width: 350px;
}

/deep/ .checkBarCode.el-dialog {
  width: 20%;
}

.going {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #EAEAEA;
  color: #999999;
  font-size: 20px;
  line-height: 36px;
  text-align: center;
  font-family: Microsoft YaHei;
}

.activeGoing {
  width: 50px;
  height: 50px;
  border: 7px solid #E3EEFF;
  border-radius: 50%;
  background: #458CFF;
  line-height: 36px;
  font-size: 20px;
  color: #FFFFFF;
  text-align: center;
}

.centerArrow {
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 16px;
  height: 15px;
  color: #D7D7D7;
  line-height: 12px;
  width: 20px;
  padding: 0;
  transform: translate(-50%, -50%);
  webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
}

.fadeLine {
  position: relative;
  border: 0.5px dashed #D7D7D7;
  height: 0;
  min-width: 200px;
}

/deep/ .importDialog {
  width: 640px;
  min-width: 640px;
}

/deep/ .el-step__title.is-process {
  color: #458CFF;
}

/deep/ .el-step__head.is-process {
  color: #458CFF;
  border-color: #458CFF;
}
</style>



// WEBPACK FOOTER //
// src/components/business/importTemplate.vue